module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_pokefuta-c932ebf0293e1b3abf6b2475836abebc.jpg";